import { ReactNode, useEffect, useState } from 'react';

interface ExternalNewsLinkProps {
  href: string;
  children: ReactNode;
  className?: string;
}

/**
 * A responsive external link component specifically for news articles.
 * 
 * Behavior:
 * - Mobile/Tablet (< 1024px): Opens in same tab for easy back navigation
 * - Desktop (>= 1024px): Opens in new tab to preserve user's place
 * 
 * Only affects external news URLs. Internal links should use react-router-dom Link.
 */
const ExternalNewsLink = ({ href, children, className = '' }: ExternalNewsLinkProps) => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    // Check initial screen size
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    // Set initial value
    checkScreenSize();

    // Listen for resize events
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  return (
    <a
      href={href}
      target={isDesktop ? '_blank' : '_self'}
      rel={isDesktop ? 'noopener noreferrer' : undefined}
      className={className}
    >
      {children}
    </a>
  );
};

export default ExternalNewsLink;
